import { render, staticRenderFns } from "./lkuItemLazzy.vue?vue&type=template&id=061cb40c"
import script from "./lkuItemLazzy.vue?vue&type=script&lang=js"
export * from "./lkuItemLazzy.vue?vue&type=script&lang=js"
import style0 from "./lkuItemLazzy.vue?vue&type=style&index=0&id=061cb40c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports